import { FC } from 'react'
import {
  StyleCard,
  StyleImageWrapper,
  StylePriceTag,
  StyleContentWrapper,
  StyleTag,
} from './style'
import Typography from '@components/typography'
import Image from '@components/image'
import Row from '@components/row'
import Button from '@components/button'
import Svg from '@components/svg'
interface HealthServiceProps {
  healthService: any
}
const HealthServiceCard: FC<HealthServiceProps> = ({ healthService }) => {
  return (
    <StyleCard>
      <StyleImageWrapper>
        <Image
          src={`${process.env.BUCKET_URL}/${healthService?.images[0]?.image}`}
        />
        <StylePriceTag>
          <Typography
            content={`Rs.${healthService?.infos?.pricePerVisit}`}
            tc="primary"
            size={14}
          />
        </StylePriceTag>
      </StyleImageWrapper>
      <StyleContentWrapper>
        <Typography content={healthService?.name} size={16} />
        <Row colGap={10}>
          <StyleTag>
            <Svg svg="plusHeart" />
            {healthService?.category?.name}
          </StyleTag>
          <StyleTag>
            <Svg svg="plusHeart" />
            {healthService?.subCategory?.name}
          </StyleTag>
        </Row>
        <Button
          title={'View Details'}
          styleButton="width:100%"
          height={40}
          radius={12}
          data-cross-id={healthService?.id}
        />
      </StyleContentWrapper>
    </StyleCard>
  )
}

export default HealthServiceCard
